import * as React from 'react';
import { SVGProps } from 'react';

const SvgIcPrint = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    {...props}
  >
    <g
      id="Iconography/Tool/ic_print"
      fill="#000"
      fillRule="evenodd"
      stroke="none"
      strokeWidth="1"
    >
      <g id="printer" fillRule="nonzero" transform="translate(2 2)">
        <path id="Path" d="M23 0v10h-2V2H7v8H5V0z"></path>
        <path
          id="Path"
          d="M28 9v10.713l-.252.284-2.357 2.655-.27.305-.407.029c-.129.01-.23.014-.314.014h-2.6v-2h2.382L26 18.953V11H2v7.926L4.022 21H6.2v2H3.178l-.294-.302-2.6-2.667-.284-.29V9z"
        ></path>
        <path id="Rectangle" d="M23 16v12H5V16zm-2 2H7v8h14z"></path>
      </g>
      <path id="Path" d="M5.2 14v2h3v-2z"></path>
    </g>
  </svg>
);

export default SvgIcPrint;
